import { withLazyLoad } from '@src/components';
import LoginPage from '@src/modules/main-app/authentication/login.page';
import { StatisticsGuard } from '@src/modules/main-app/statistics';
import { lazy, ReactElement } from 'react';
import { Route, Routes } from 'react-router-dom';

const CalendarPage = lazy(() => import('~/modules/main-app/calendar/calendar.page'));
const ContactsPage = lazy(() => import('~/modules/main-app/contacts/contacts.page'));
const ExclusionsPage = lazy(() => import('~/modules/main-app/exclusions/exclusions.page'));
const InteractionPage = lazy(() => import('~/modules/main-app/interaction/interaction.page'));
const NotFoundPage = lazy(() => import('~/modules/not-found.page'));
const StatisticsPage = lazy(() => import('~/modules/main-app/statistics/statistics.page'));
const ExportPage = lazy(() => import('~/modules/main-app/export/export.page'));
const UsersPage = lazy(() => import('~/modules/main-app/users/users.page'));
const ProjectsPage = lazy(() => import('~/modules/main-app/projects/projects.page'));

const MainAppRouter = (): ReactElement => (
  <Routes>
    {/*
      A raiz é vazia de propósito: este app não tem home, o usuário entra por
      um item do menu. Cair no NotFoundPage aqui anunciava um erro onde não há
      nenhum -- era a primeira tela de quem acabava de logar.

      O fragmento é explícito porque uma Route sem `element` não renderiza
      nada: ela cai no Outlet implícito, e a intenção se perderia.
    */}
    <Route path='/' element={<></>} />
    <Route path='/calendar/:month?' element={withLazyLoad(<CalendarPage />)} />
    <Route path='/contacts/:contactId?' element={withLazyLoad(<ContactsPage />)} />
    <Route path='/exclusions' element={withLazyLoad(<ExclusionsPage />)} />
    <Route path='/interaction/:page' element={withLazyLoad(<InteractionPage />)} />
    <Route path='/login' element={withLazyLoad(<LoginPage />)} />
    <Route
      path='/statistics'
      element={withLazyLoad(
        <StatisticsGuard>
          <StatisticsPage />
        </StatisticsGuard>
      )}
    />
    <Route path='/export' element={withLazyLoad(<ExportPage />)} />
    <Route path='/users' element={withLazyLoad(<UsersPage />)} />
    <Route path='/projects' element={withLazyLoad(<ProjectsPage />)} />
    <Route path='*' element={withLazyLoad(<NotFoundPage />)} />
  </Routes>
);

export { MainAppRouter };
